function initRecentPublications(section) {
  if (section.dataset.pubInitialized) return;
  section.dataset.pubInitialized = "true";

  const chips = section.querySelectorAll(".pub-chip");
  const panels = section.querySelectorAll(".pub-panel");

  // Read slugs from data attribute set by PHP
  const knownSlugs = JSON.parse(section.dataset.knownSlugs || "[]");
  const pathParts = window.location.pathname.replace(/\/$/, "").split("/");
  const lastPart = pathParts[pathParts.length - 1];
  const basePath = knownSlugs.includes(lastPart)
    ? pathParts.slice(0, -1).join("/")
    : pathParts.join("/");

  function activate(slug, index) {
    // Update chips
    chips.forEach((chip) => {
      const isActive = chip.dataset.index == index;
      chip.classList.toggle("bg-brand-dark-red", isActive);
      chip.classList.toggle("text-white", isActive);
      chip.classList.toggle("border-brand-dark-red", isActive);
      chip.classList.toggle("border-brand-dark-blue", !isActive);
      chip.classList.toggle("text-brand-dark-blue", !isActive);
    });

    // Update panels
    panels.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panelIndex != index);
    });

    // Update URL
    const newUrl = basePath + "/" + slug;
    history.pushState({ slug, index }, "", newUrl);
  }

  // Chip clicks
  chips.forEach((chip) => {
    chip.addEventListener("click", function () {
      activate(this.dataset.slug, this.dataset.index);
    });
  });

  // Bottom nav buttons
  section.querySelectorAll(".pub-nav-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      activate(this.dataset.slug, this.dataset.index);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });

  // Browser back/forward
  window.addEventListener("popstate", function (e) {
    if (e.state) {
      activate(e.state.slug, e.state.index);
    }
  });

  // Full Screen buttons — use dFlip's JS API
  section.querySelectorAll(".pub-fullscreen-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const panelIndex = this.dataset.panel;
      const panel = section.querySelector(
        `.pub-panel[data-panel-index="${panelIndex}"]`,
      );
      if (!panel) return;

      // Try dFlip's fullscreen UI button
      const dflipFsBtn = panel.querySelector(".df-ui-btn.df-ui-fullscreen");
      if (dflipFsBtn) {
        dflipFsBtn.click();
        return;
      }

      // Fallback: use dFlip's JS API directly via the flipbook object
      const flipWrapper = panel.querySelector('.df-container, [id^="df-"]');
      if (flipWrapper) {
        const flipId = flipWrapper.id;
        if (
          flipId &&
          window.DFLIP &&
          DFLIP.flipBooks &&
          DFLIP.flipBooks[flipId]
        ) {
          DFLIP.flipBooks[flipId].fullScreen();
        }
      }
    });
  });
}

// Initialize on DOMContentLoaded and observe for dynamic insertion
function initAllRecentPublications() {
  document
    .querySelectorAll('[data-testid="section-recent-publications"]')
    .forEach(initRecentPublications);
}

document.addEventListener("DOMContentLoaded", initAllRecentPublications);

const mo = new MutationObserver(initAllRecentPublications);
mo.observe(document.body, { childList: true, subtree: true });
